"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LANGUAGE_CODE = exports.DEFAULT_LANGUAGE = void 0;
const LANGUAGE_CODE = exports.LANGUAGE_CODE = {
  de_DE: 'German',
  en_US: 'English',
  nl_NL: 'Dutch',
  no_NO: 'Norwegian',
  da_DK: 'Danish',
  sv_SE: 'Swedish',
  ar_AA: 'Arabic',
  fr_FR: 'French',
  it_IT: 'Italian',
  es_ES: 'Spanish'
};
const DEFAULT_LANGUAGE = exports.DEFAULT_LANGUAGE = 'de_DE';